// document.querySelector('#delivery-items').style.display = 'none';

// console.log('Custom JS');

const tabsAccordion = document.querySelector('.faq_section .faqs-row .tabs-accordion');
console.log(tabsAccordion);

tabsAccordion?.addEventListener('click', function (e) {
    // console.log(e.target);

    const targetElement = e.target;

    targetElement.classList.toggle('active');

    const nextSiblingElement = targetElement.nextElementSibling;
    // console.log(nextSiblingElement);

    nextSiblingElement.classList.toggle('active');
});









const modal = document.querySelector(".cstm-modal");
const overlay = document.querySelector(".cstm-overlay");
const openButton = document.querySelector(".cstm-paypal-info");
const closeButton = document.querySelector(".cstm-close-btn");

// Open modal and add `show` class to modal and overlay
openButton.addEventListener("click", () => {
  modal.classList.add("show");
  overlay.classList.add("show"); // Add `show` class to overlay
  document.body.classList.add("no-scroll"); // Disable body scroll
});

// Close modal and remove `show` class from modal and overlay
closeButton.addEventListener("click", () => {
  modal.classList.remove("show");
  overlay.classList.remove("show"); // Remove `show` class from overlay
  document.body.classList.remove("no-scroll"); // Enable body scroll
});








